import React from "react";
import StudentForgotPasswordLayer from "./StudentForgotPasswordLayer";

const StudentForgotPasswordPage = () => {
  return (
    <>
      {/* ForgotPasswordLayer */}
      <StudentForgotPasswordLayer />
    </>
  );
};

export default StudentForgotPasswordPage;
